export default __webpack_public_path__ + "static/media/ic-Remarks.52411275.svg";